<!--ion-slides pager>
  <ion-slide>
    <div class="slide">
      <img style="height:50vw" src="/assets/images/logo.png" />
      <h2>Welcome</h2>
      <p>
        Share it or it didn't happen! This is the rule! <b>RunnerGram</b> is the solution to these boring screenshots of your activities.<br>Add some magic to your content with our interactive stickers, maps, stats, comments, segments, PBs and more!<br>Lets make some noise!
      </p>
    </div>
  </ion-slide>

  <ion-slide>
    <img src="/assets/images/poweredByStrava.png" />
    <h2>Load Activities</h2>
    <p>
      Connect with <b>STRAVA</b>. Other platforms will follow in the future, but the app is designed to automatically get your activities from strava and store them locally. Your data is absolutely safe. Nothing is shared. You can always upload a custom activity but not all options will be available. Your can remove your data at any point.
    </p>
  </ion-slide>

  <ion-slide>
    <div class="gif">
      <img class="phone" src="/assets/images/phone.png" />
    </div>
    <h2>How to use</h2>
    <p>
      Select your activity. Set your background. Add as many stickers as you want. Maps, stats, laps etc. Position them in the grid. <b>Share!</b> That's it.
    </p>
  </ion-slide>

  <ion-slide>
    <img style="height:50vw" src="/assets/images/logo.png" />
    <h2>Ready to Play?</h2>
    <p>Feel free to follow us on instagram<br>
      <ion-button fill="clear" (click)="instaFollow()">
        <ion-icon size="small" name="logo-instagram"></ion-icon>
        runnergram
      </ion-button><br>and mention us in your stories. We have a lot of goodies in the roadmap. Feedback is welcomed. You can come back at this tutorial at any time!</p>
    <ion-button fill="clear" (click)="closeTutorial()">Continue <ion-icon slot="end" name="arrow-forward"></ion-icon></ion-button>
  </ion-slide>


</ion-slides-->
<ion-button fill="clear" (click)="closeTutorial()">Continue <ion-icon slot="end" name="arrow-forward"></ion-icon></ion-button>
 